<template>
    <button
    v-on:click.stop="toggleMenu"
    class="navigation-hamburger"
    v-bind:class="{ '-open': isNavMenuOpened, '-close': !isNavMenuOpened }"
    aria-label="menu"
    aria-controls="menu"
    v-bind:aria-hidden="[ isHotspotPanelOpened ? 'true' : 'false' ]"
    v-bind:tabindex="[ isHotspotPanelOpened ? '-1' : '0' ]"
    v-bind:aria-expanded="[ isNavMenuOpened ? 'true' : 'false'  ]">

        <div class="container">
            <div class="circle"></div>
            <div class="bar-wrap">
                <div class="bar bar1"></div>
                <div class="bar bar2"></div>
                <div class="bar bar3"></div>
            </div>
            <div class="cross-wrap">
                <div class="cross-line cross-line1"></div>
                <div class="cross-line cross-line2"></div>
            </div>
        </div>

    </button>
</template>

<script>
    import { openNavMenu, closeNavMenu, openNavMenuDelay, closeNavMenuDelay } from '../vuex/actions'

    export default {
        vuex: {
            getters: {
                isNavMenuOpened: state => state.isNavMenuOpened,
                isHotspotPanelOpened: state => state.isHotspotPanelOpened
            },
            actions: {
                openNavMenu,
                closeNavMenu,
                openNavMenuDelay,
                closeNavMenuDelay
            }
        },

        methods: {
            'toggleMenu': function () {
                if (this.isNavMenuOpened) {
                    this.closeNavMenu()

                    setTimeout(function () {
                        this.closeNavMenuDelay()
                    }.bind(this), 100)
                } else {
                    this.openNavMenu()

                    setTimeout(function () {
                        this.openNavMenuDelay()
                    }.bind(this), 400)
                }
            }
        }
    }
</script>

<style lang="scss">
    @import '../assets/sass/global';

    .v-loading .navigation-hamburger .circle {
        transition: transform 0s ease-out;
    }

    .v-loading-first .navigation-hamburger {
        transition: color .3s ease, transform .2s ease-out .2s;
        transform: scale(0);
    }

    .-global-overlay .navigation-hamburger {
        transform: scale(1) translateY(-10rem);

        @include gridle_state(large) {
            transform: scale(1) translateY(-10rem);
        }
    }

    .navigation-hamburger {
        margin: $nav-icon-distance-mobile;
        transition: transform 0.4s ease-out .3s;
        transform: scale(1);
        display: block;
        position: absolute;
        z-index: 99;
        line-height: $nav-icon-total-height;
        top: 0;
        right: 0;
        padding: $nav-icon-extra-space;
        cursor: pointer;
        user-select: none;
        outline: 0;
        opacity: 1;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        -moz-tap-highlight-color: rgba(0, 0, 0, 0);

        @include gridle_state(large) {
            margin: $nav-icon-distance;
        }

        &.hidden:not(.open) {
            .bars {
                opacity: 0;
            }
        }

        .container {
            display: block;
            position: relative;
            padding: 1.6rem;
            width: 100%;
            height: 100%;
        }

        .circle {
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            background-color: $nav-container-color;
            border-radius: 50%;
            width: 100%;
            height: 100%;
            transition: width $nav-backshape-timing/2 ease-out, height $nav-backshape-timing/2 ease-out;
        }

        .bar-wrap {
            @include middlePos();
            transition: margin .2s ease, transform .2s ease .8s, opacity .3s ease;
            overflow: hidden;
            width: $nav-icon-width;
        }

        .bar {
            height: $nav-icon-thickness;
            background: $nav-icon-color;
            display: block;
            margin: $nav-icon-spacing auto;
            border-radius: 5px;
        }

        .cross-wrap {
            @include middlePos();
            transition: margin .2s ease, transform .2s ease 1s, opacity .3s ease;
            width: $nav-icon-width * 1.2;
            height: $nav-icon-width * 1.2;
            overflow: hidden;
            .cross-line {
                height: 100%;
                width: 2px;
                background: black;
                position: absolute;
                border-radius: 5px;
                left: 9px;
            }
            .cross-line1 {
                transform: translateY(-30px) translateX(30px) rotate(45deg);
            }
            .cross-line2 {
                transform: translateY(-30px) translateX(-30px) rotate(-45deg);
            }
        }

        &:hover {
            .circle {
                width: 110%;
                height: 110%;
            }
        }

        &.-open {
            color: $black;
            z-index: 4;

            .circle {
                transition: width $nav-backshape-timing ease-out, height $nav-backshape-timing ease-out;
                transition-delay: 0.3s;
                width: 450vh;
                height: 450vh;

                @include gridle_state(medium) {
                    width: 450vw;
                    height: 450vw;
                }
            }

            .bar, .cross-line {
                animation-duration: 0.5s;
                animation-fill-mode: forwards;
            }
            .bar1 {
                animation-name: jiggleLeft;
                animation-delay: 0.45s;
            }
            .bar2 {
                animation-name: jiggleRight;
                animation-delay: 0.30s;
            }
            .bar3 {
                animation-name: jiggleLeft;
                animation-delay: 0.15s;
            }
            .cross-line1 {
                animation-name: crossRight;
                animation-delay: 0.8s;
            }
            .cross-line2 {
                animation-name: crossLeft;
                animation-delay: 0.65s;
            }
        }

        &.-close {
            .bar, .cross-line {
                animation-duration: 0.5s;
                animation-fill-mode: forwards;
            }
            .bar1 {
                transform: translateX(-25px);
                animation-name: jiggleClose;
                animation-delay: 0.50s;
            }
            .bar2 {
                transform: translateX(25px);
                animation-name: jiggleClose;
                animation-delay: 0.65s;
            }
            .bar3 {
                transform: translateX(-25px);
                animation-name: jiggleClose;
                animation-delay: 0.80s;
            }
            .cross-line1 {
                transform: translateY(0px) translateX(0px) rotate(-45deg);
                animation-name: crossLeftClose;
                animation-delay: 0.15s;
            }
            .cross-line2 {
                transform: translateY(0px) translateX(0px) rotate(45deg);
                animation-name: crossRightClose;
                animation-delay: 0.30s;
            }
        }
    }

    @keyframes jiggleLeft {
        50% {
            transform: translateX(10px);
        }
        100% {
            transform: translateX(-25px);
        }
    }
    @keyframes jiggleRight {
        50% {
            transform: translateX(-10px);
        }
        100% {
            transform: translateX(25px);
        }
    }
    @keyframes jiggleClose {
        0%{
            transform: translateX(-25px);
        }
        50% {
            transform: translateX(10px);
        }
        100% {
            transform: translateX(0px);
        }
    }

    @keyframes crossLeft {
        100% {
            transform: translateY(0px) translateX(0px) rotate(-45deg);
        }
    }
    @keyframes crossLeftClose {
        100% {
            transform: translateY(30px) translateX(30px) rotate(-45deg);
        }
    }
    @keyframes crossRight {
        100% {
            transform: translateY(0px) translateX(0px) rotate(45deg);
        }
    }
    @keyframes crossRightClose {
        100% {
            transform: translateY(30px) translateX(-30px) rotate(45deg);
        }
    }
</style>



// WEBPACK FOOTER //
// NavigationHamburger.vue?3694bf14